var _stop, _stop2, _stop3, _stop4, _stop5, _stop6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgTocDefaultSvg = function SvgTocDefaultSvg(props) {
  var _id3 = useUniqueInlineId();
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.596 115.572C120.474 119.948 115.029 127.701 106.771 134.828C98.5127 141.894 89.9486 146.208 85.3606 145.895C85.2994 145.895 85.2383 145.895 85.1159 145.895C84.9936 145.895 84.9936 145.895 84.8712 145.895C80.3444 146.208 71.7191 141.894 63.4608 134.828C55.1413 127.701 49.6969 119.948 49.6357 115.572V75.2445C49.7581 72.8061 51.5321 70.7429 53.8567 70.3052C61.6256 67.9919 78.0811 63.3652 85.0547 63.3652C92.0284 63.3652 108.484 67.9919 116.253 70.3678C118.577 70.8054 120.351 72.8687 120.474 75.307L120.596 115.572Z",
    fill: "url(#".concat(_id, ")"),
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.596 115.572C120.474 119.948 115.029 127.701 106.771 134.828C98.5127 141.894 89.9486 146.208 85.3606 145.895C85.2994 145.895 85.2383 145.895 85.1159 145.895C84.9936 145.895 84.9936 145.895 84.8712 145.895C80.3444 146.208 71.7191 141.894 63.4608 134.828C55.1413 127.701 49.6969 119.948 49.6357 115.572V75.2445C49.7581 72.8061 51.5321 70.7429 53.8567 70.3052C61.6256 67.9919 78.0811 63.3652 85.0547 63.3652C92.0284 63.3652 108.484 67.9919 116.253 70.3678C118.577 70.8054 120.351 72.8687 120.474 75.307L120.596 115.572Z",
    fill: "url(#".concat(_id2, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4557 113.601H76.8887C75.232 113.601 73.8765 112.257 73.8765 110.614V99.1623C73.8765 97.5193 75.232 96.175 76.8887 96.175C77.1659 96.175 77.3907 95.9502 77.3907 95.673V92.6898C77.5413 88.4578 81.1057 85.0722 85.4232 85.2216C89.5399 85.3709 92.8031 88.6072 92.9537 92.6898V95.673C92.9537 95.9502 93.1785 96.175 93.4557 96.175C95.1124 96.175 96.4679 97.5193 96.4679 99.1623V110.614C96.4679 112.257 95.1124 113.601 93.4557 113.601ZM83.4151 107.377C83.4151 108.323 84.2183 109.12 85.1722 109.12C86.1261 109.12 86.9293 108.323 86.9293 107.377V102.399C86.9293 101.453 86.1261 100.656 85.1722 100.656C84.2183 100.656 83.4151 101.453 83.4151 102.399V107.377ZM89.4395 93.1877C89.4395 93.0881 89.4395 93.0383 89.4395 92.9388C89.4395 90.5987 87.5317 88.7067 85.1722 88.7067C82.8126 88.7067 80.9049 90.5987 80.9049 92.9388C80.9049 93.0383 80.9049 93.0881 80.9049 93.1877V94.9388C80.9049 95.6215 81.4584 96.175 82.1411 96.175H88.2033C88.886 96.175 89.4395 95.6215 89.4395 94.9388V93.1877Z",
    fill: "url(#".concat(_id3, ")")
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 49.6476,
    y1: 128.367,
    x2: 97.895,
    y2: 61.3614,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88BBFA"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7DDFF",
    stopOpacity: 0.85
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 110.701,
    y1: 57.6099,
    x2: 39.3855,
    y2: 66.1588,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEDEFF",
    stopOpacity: 0.239973
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED9FF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id3,
    x1: 96.4679,
    y1: 111.622,
    x2: 91.5492,
    y2: 83.5476,
    gradientUnits: "userSpaceOnUse"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF9FF"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF7FF"
  })))));
};
export default SvgTocDefaultSvg;